import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { Menu, X } from 'lucide-react';
import './Header.css';
import { Link as RouterLink } from 'react-router-dom';

// 1. Importamos la imagen correctamente para evitar enlaces rotos en producción
// import logoImg from '/img/images/logo.png';

const Header = ({ scrolled }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1023);
      if (window.innerWidth > 1023) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
      <div className="container header-container">
        <div className="logo">
          <RouterLink to="/" onClick={closeMenu} className="logo-link">
            {/* 2. Usamos la variable importada en lugar del string */}
            <img src={'/img/logo.png'} alt="VillaTracking Logo" />
          </RouterLink>
        </div>

        <nav className={`nav ${menuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li className="nav-item">
              <Link
                to="home"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={closeMenu}
                className="nav-link"
              >
                Inicio
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="features"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={closeMenu}
                className="nav-link"
              >
                Características
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="how-it-works"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={closeMenu}
                className="nav-link"
              >
                Cómo Funciona
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="benefits"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={closeMenu}
                className="nav-link"
              >
                Beneficios
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="pricing"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={closeMenu}
                className="nav-link"
              >
                Precios
              </Link>
            </li>
            
            {/* 3. Nuevo Enlace al Manual de Usuario */}
            {/* <li className="nav-item">
              <a 
                href="/manual" 
                target="_blank" 
                rel="noopener noreferrer" 
                onClick={closeMenu} 
                className="nav-link manual-link"
              >
                Manual <span style={{ fontSize: '0.85em', marginLeft: '2px' }}>↗</span>
              </a>
            </li> */}

            <li className="nav-item">
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={closeMenu}
                className="nav-link"
              >
                Contacto
              </Link>
            </li>
          </ul>
        </nav>

        <div className="header-buttons">
          <a href="https://app.villatracking.com" className="btn btn-secondary" target='_blank' rel='noopener noreferrer'>Iniciar Sesión</a>
          <Link
            to="contact"
            spy={true}
            smooth={true}
            offset={-80}
            duration={500}
            className="btn btn-primary"
          >
            Solicitar Demo
          </Link>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;